import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=1f6cf13b&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=ts&"
export * from "./Share.vue?vue&type=script&lang=ts&"
import style0 from "./Share.vue?vue&type=style&index=0&id=1f6cf13b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6cf13b",
  null
  
)

export default component.exports